import React, { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { Redirect } from 'react-router';
import { AppRoute, AppSwitch, RoutedComponentProps } from 'src/app-routes';
import { PageSideNav, RouteGroup } from 'src/components-dummy';
import { ShopFeature } from 'src/app-types';
import { useAppNavigation } from 'src/hooks/useAppNavigation';
import { TourAndGalleryContainer } from '../TourAndGallery';
import {
  VisualSearchLayout,
  VisualSearchSidebar,
  VisualSearchContent,
} from './VisualSearchContainer.styles';

interface VisualSearchContainerProps extends RoutedComponentProps {
  shopId: number;
  enabledShopFeatures: Set<ShopFeature>;
}

export const VisualSearchContainer = ({
  shopId,
  permittedRouteMap,
  enabledShopFeatures,
}: VisualSearchContainerProps): JSX.Element => {
  const navigateTo = useAppNavigation();

  const sideNavRoutes = useMemo<RouteGroup[]>(() => {
    const subRoutes = [
      { route: permittedRouteMap.tourAndGallery, feature: ShopFeature.InspirationGallery },
    ]
      .filter(({ route, feature }) => route && enabledShopFeatures.has(feature))
      .map(({ route }) => ({
        url: generatePath(route.path, { shopId }),
        title: route.title,
        pathTemplate: route.path,
      }));

    return [{ routes: subRoutes }];
  }, [permittedRouteMap.tourAndGallery, shopId, enabledShopFeatures]);

  return (
    <VisualSearchLayout>
      <VisualSearchSidebar>
        <PageSideNav
          pageTitle='Visual search'
          routeGroups={sideNavRoutes}
          handleNavigate={navigateTo}
        />
      </VisualSearchSidebar>
      <VisualSearchContent>
        <AppSwitch>
          <AppRoute route={permittedRouteMap.tourAndGallery} Component={TourAndGalleryContainer} />
          {permittedRouteMap.tourAndGallery && (
            <Redirect to={generatePath(permittedRouteMap.tourAndGallery.path, { shopId })} />
          )}
        </AppSwitch>
      </VisualSearchContent>
    </VisualSearchLayout>
  );
};
